import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";

const useIndexedByWritingType = (siteId?: number) => {
    const [indexedByWritingType, setIndexedByWritingType] = useState<any>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(true);

    const fetch = () => {
        if (!siteId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        OrderTransport.listIndexedByWritingType(siteId)
            .then((res) => {
                let filteredData = {};
                res.forEach(
                    (el: any) =>
                        (filteredData = {
                            ...filteredData,
                            [el.writingType]: `${el.indexed || "0"} / ${el.totalOrders || "0"}`,
                        })
                );
                setIndexedByWritingType([filteredData]);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        fetch();
    }, [siteId]);

    return { indexedByWritingType, loading, error, refresh };
};

export default useIndexedByWritingType;
